import React, { FC } from 'react';
import SidebarView from 'src/shared/InfoSidebar/SidebarView';
import { useCurrentSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import CallOfPreview from '../CallOffPreview';
import InboxPreview from '..//InboxPreview';

interface Props {
  className?: string;
}
const CallOffsSidebars: FC<Props> = ({ className }) => {
  const sidebarState = useCurrentSidebar();

  return (
    <>
      {sidebarState && (
        <SidebarView className={className}>
          {sidebarState.mode === SidebarMode.CALL_OFF_INFO && sidebarState.id && (
            <CallOfPreview key={sidebarState.id} />
          )}
          {sidebarState.mode === SidebarMode.INBOX_INFO && sidebarState.id && <InboxPreview key={sidebarState.id} />}
        </SidebarView>
      )}
    </>
  );
};

export default CallOffsSidebars;
